// @ts-nocheck

export const API_URL = import.meta.env.VITE_ALFINDER_URL + '/v1';

export const getApiUrl = (storeId: string) => {
  return API_URL;
};
